module.exports = __webpack_public_path__ + "img/analytics-marketing-team-6.615de333.svg";